module.exports = __webpack_public_path__ + "img/Assurance.efaa3e1e.png";